export const PIIDefaults = {
  postalCode: "",
  phoneNumber: "",
  firstName: "",
  lastName: "",
}
